// extracted by mini-css-extract-plugin
export default {"root":"Header_root__h8UiF","logo":"Header_logo__LPzEO","logo2":"Header_logo2__k5wCH","logoText":"Header_logoText__1Nl3b"};